import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';
import rootReducer from './rootReducer';

export const configureStore = () => {
  const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(ReduxThunk)));

  return store;
};



// WEBPACK FOOTER //
// ./src/common/store.ts